const stopPropagation = e => {
  e.stopPropagation();
};
const stopMousedownPropagation = instance => e => {
  if (instance.container === e.target) {
    e.stopPropagation();
  }
};
export const disableDragEventPropagation = ({
  instance,
  propagateDragEvent
}) => {
  if (!propagateDragEvent) {
    instance.container.addEventListener('mousedown', stopMousedownPropagation(instance));
    instance.container.addEventListener('mousemove', stopPropagation);
    instance.container.addEventListener('touchmove', stopPropagation);
  }
};
export const removeDisableDragEventPropagation = ({
  instance,
  propagateDragEvent
}) => {
  if (!propagateDragEvent) {
    instance.container.removeEventListener('mousedown', stopMousedownPropagation(instance));
    instance.container.removeEventListener('mousemove', stopPropagation);
    instance.container.removeEventListener('touchmove', stopPropagation);
  }
};
//# sourceMappingURL=disableDragEventPropagation.js.map